import { render, staticRenderFns } from "./restore_resume.vue?vue&type=template&id=bfdead90&scoped=true&"
import script from "./restore_resume.vue?vue&type=script&lang=js&"
export * from "./restore_resume.vue?vue&type=script&lang=js&"
import style0 from "./restore_resume.vue?vue&type=style&index=0&id=bfdead90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdead90",
  null
  
)

export default component.exports